import { create } from "zustand"

type InviteUserDialogState = {
    isOpen: boolean
}

type InviteUserDialogActions = {
    onOpen: () => void
    onClose: () => void
}

const useInviteUserDialogV1 = create<
    InviteUserDialogState & InviteUserDialogActions
>((set) => ({
    isOpen: false,
    onOpen: () => set({ isOpen: true }),
    onClose: () => set({ isOpen: false }),
}))

export default useInviteUserDialogV1
